import {
    AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
    AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

// Konfirmasi peringatan lunak sebelum menyimpan (dipakai panel Input Rotasi Cepat & dialog Isi Massal).
// baris = teks per peringatan; pesanHariPenuh = kalimat >= ambang dari server (null bila tidak ada).
export default function KonfirmasiPeringatanRotasi({ open, baris, pesanHariPenuh, onBatal, onLanjut }) {
    return (
        <AlertDialog open={open} onOpenChange={(o) => !o && onBatal()}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle className="flex items-center gap-2">
                        <AlertTriangle className="w-4 h-4 text-amber-600" />
                        {pesanHariPenuh ? "Pastikan sudah benar" : "Tanggal tumpang tindih"}
                    </AlertDialogTitle>
                    <AlertDialogDescription asChild>
                        <div className="space-y-1 text-sm max-h-72 overflow-y-auto" data-testid="rc-konfirmasi-isi">
                            {pesanHariPenuh && <div className="font-semibold">{pesanHariPenuh}</div>}
                            {baris.map((t, i) => <div key={i}>{t}</div>)}
                            {!pesanHariPenuh && <div className="pt-1">Lanjutkan menyimpan?</div>}
                        </div>
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel data-testid="rc-periksa-lagi">Periksa lagi</AlertDialogCancel>
                    <AlertDialogAction className="bg-[#00B9AD] hover:bg-[#60C0D0]" data-testid="rc-lanjut-simpan" onClick={onLanjut}>
                        {pesanHariPenuh ? "Ya, sudah benar" : "Lanjutkan"}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
